module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dof-lottery-rain weex-ct weex-div",
    style: (_vm._px2rem(_vm.wrapStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.picList), function(src, i) {
    return _c('rain-item', {
      key: i,
      ref: ("rain-item-" + i),
      refInFor: true,
      attrs: {
        "src": src,
        "rain-id": i,
        "data-evt-dofLotteryRainCaught": ""
      },
      on: {
        "dofLotteryRainCaught": _vm.dofLotteryRainCaught
      }
    })
  }), 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5cd35c13", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cd35c13","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-lottery-rain/index.vue
// module id = 618
// module chunks = 0 1